// Angular imports
import { Component, EventEmitter, Output, Input, SimpleChanges, OnChanges } from '@angular/core';

// cc-common imports
import { IconConstants } from 'cc-common';

@Component({
    selector: 'app-notes-viewer',
    templateUrl: './notes-viewer.component.html',
    styleUrls: ['./notes-viewer.component.scss']
})
export class NotesViewerComponent implements OnChanges {
    @Input() previousNotes: string;
    @Output() notesPopUpClose = new EventEmitter<boolean>();

    iconClose = IconConstants.CLOSE;

    ngOnChanges(changes: SimpleChanges) {
        if (changes.previousNotes && changes.previousNotes.currentValue) {
            this.previousNotes = changes.previousNotes.currentValue;
        }
    }

    onCloseClick(): void {
        this.clearAllFields();
        this.notesPopUpClose.emit(false);
    }

    private clearAllFields(): void {
        this.previousNotes = null;
    }
}
